import * as React from 'react';

const MintdataLogo2 = (props:any) => (
    <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path stroke="#FFF" strokeWidth="2" d="M1 1h30v30H1z" />
            <path fill="#FFF"
                  d="M8.48 8.72H12l3.94 11.18h.04l3.84-11.18h3.48V23h-2.38V11.98h-.04L16.92 23h-2.06L10.9 11.98h-.04V23H8.48z" />
        </g>
    </svg>
);

export default MintdataLogo2;

